/**
 * @generated SignedSource<<545ab1fca9dcafb7ea34b0c707c7ad4c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type composerPresetConfigurationsQuery$variables = {
  after?: string | null;
  count?: number | null;
  modelID: number;
};
export type composerPresetConfigurationsQuery$data = {
  readonly compositionMacroCategories: ReadonlyArray<{
    readonly category: ReadonlyArray<{
      readonly categoryID: number;
      readonly name: string | null;
    } | null> | null;
    readonly macroCategoryID: number;
    readonly name: string | null;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"composerPresetConfigurations_list">;
};
export type composerPresetConfigurationsQuery = {
  response: composerPresetConfigurationsQuery$data;
  variables: composerPresetConfigurationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": 60,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelID"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "macroCategoryID",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryID",
  "storageKey": null
},
v6 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v7 = {
  "kind": "Variable",
  "name": "modelID",
  "variableName": "modelID"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = [
  (v6/*:: as any*/),
  {
    "kind": "Literal",
    "name": "draft",
    "value": false
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "isTemplate",
    "value": true
  },
  (v7/*:: as any*/),
  {
    "kind": "Literal",
    "name": "page",
    "value": 1
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "composerPresetConfigurationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CompositionMacroCategory",
        "kind": "LinkedField",
        "name": "compositionMacroCategories",
        "plural": true,
        "selections": [
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CompositionCategory",
            "kind": "LinkedField",
            "name": "category",
            "plural": true,
            "selections": [
              (v5/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          (v6/*:: as any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          (v7/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "composerPresetConfigurations_list"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "composerPresetConfigurationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CompositionMacroCategory",
        "kind": "LinkedField",
        "name": "compositionMacroCategories",
        "plural": true,
        "selections": [
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CompositionCategory",
            "kind": "LinkedField",
            "name": "category",
            "plural": true,
            "selections": [
              (v5/*:: as any*/),
              (v4/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*:: as any*/),
        "concreteType": "CompositionsPagedConnection",
        "kind": "LinkedField",
        "name": "compositionsPaged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompositionsPagedEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Composition",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "compositionID",
                    "storageKey": null
                  },
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "previewImageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompositionTemplateCategory",
                    "kind": "LinkedField",
                    "name": "categories",
                    "plural": true,
                    "selections": [
                      (v5/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*:: as any*/),
        "filters": [
          "page",
          "modelID",
          "isTemplate",
          "draft"
        ],
        "handle": "connection",
        "key": "composerPresetConfigurations_list_compositionsPaged",
        "kind": "LinkedHandle",
        "name": "compositionsPaged"
      }
    ]
  },
  "params": {
    "cacheID": "cfa00222ba6ae593456378853e3d81dd",
    "id": null,
    "metadata": {},
    "name": "composerPresetConfigurationsQuery",
    "operationKind": "query",
    "text": "query composerPresetConfigurationsQuery(\n  $modelID: Long!\n  $count: Int = 60\n  $after: String\n) {\n  compositionMacroCategories {\n    macroCategoryID\n    name\n    category {\n      categoryID\n      name\n      id\n    }\n    id\n  }\n  ...composerPresetConfigurations_list_1zGMVt\n}\n\nfragment composerPresetConfigurations_list_1zGMVt on Query {\n  compositionsPaged(first: $count, after: $after, page: 1, modelID: $modelID, isTemplate: true, draft: false) {\n    edges {\n      node {\n        id\n        compositionID\n        name\n        previewImageUrl\n        categories {\n          categoryID\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e0983ea401cdcc28f7816ec8ef2e8d1";

export default node;
